const EVENT = {
  CART: {
    UPDATE: 'cart:update',
  },
  ACCORDION: {
    DRAWERCLOSED: 'accordion-drawer:closed',
    CHILDDRAWERCLOSED: 'accordion-child-drawer:closed',
  },
  DRAWER: {
    OPEN: 'drawer:open',
    CLOSE: 'drawer:close',
    TOGGLE: 'drawer:toggle',
  },
  OVERLAY: {
    DEACTIVATE: 'page-overlay:deactivate',
    ACTIVATE: 'page-overlay:activate',
  },
  HEADER: {
    WHITE: 'header:white',
  },
};

export default EVENT;
